export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["激活电子支票"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["存款账户"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["数字"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["系列"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["激活码"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["查看"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["启用"])}
}